import { css, keyframes } from '@emotion/react'
import styled from '@emotion/styled'
import convert from 'color-convert'

import motion from '../../theme/motion'
import { Flex } from '../layout/Flex'

export type DimmerVariant = 'blend' | 'solid'

export interface DimmerProps {
  variant?: DimmerVariant
  /**
   * When true, enables the fade-in animation.
   */
  enableAnimation?: boolean
}

const Dimmer = styled(Flex)<DimmerProps>`
  width: 100%;
  inset: 0 0 0 0;
  position: fixed;
  z-index: 99999;
  ${({ enableAnimation = true }) =>
    enableAnimation &&
    css`
      animation: ${motion.fadeIn} 150ms forwards;
    `};
  flex-direction: column;
  background: ${props => props.theme.arcadeColors.semantic.backgroundDimmer};

  ${props => props.theme.breakpoints.tablet} {
    ${props =>
      props.enableAnimation &&
      css`
        animation: ${keyframes({
            '0%': { background: 'rgba(0, 0, 0, 0)' },
            '100%': {
              background: props.theme.arcadeColors.semantic.backgroundDimmer,
              backdropFilter: 'blur(.06rem)',
            },
          })}
          200ms forwards;
      `}
    background: ${props => props.theme.arcadeColors.semantic.backgroundDimmer};
    backdrop-filter: blur(0.06rem);
  }

  ${props =>
    props.variant === 'blend' &&
    css`
      background: rgba(${convert.hex.rgb(props.theme.arcadeColors.semantic.backgroundApp).join(',')}, 90%);
    `}

  ${props =>
    props.variant === 'solid' &&
    css`
      background: ${props.theme.arcadeColors.semantic.backgroundApp};
    `}
`

export default Dimmer
